import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5906a1d0 = () => interopDefault(import('../../../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */))
const _34d0b7e0 = () => interopDefault(import('../../../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */))
const _7bac491b = () => interopDefault(import('../../../pages/info/index.vue' /* webpackChunkName: "pages/info/index" */))
const _65407a9c = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _295cef5c = () => interopDefault(import('../../../pages/maintenance/index.vue' /* webpackChunkName: "pages/maintenance/index" */))
const _5bf46e56 = () => interopDefault(import('../../../pages/info/about.vue' /* webpackChunkName: "pages/info/about" */))
const _330f0529 = () => interopDefault(import('../../../pages/info/contact.vue' /* webpackChunkName: "pages/info/contact" */))
const _eb89dede = () => interopDefault(import('../../../pages/info/privacy.vue' /* webpackChunkName: "pages/info/privacy" */))
const _25aa0750 = () => interopDefault(import('../../../pages/info/terms.vue' /* webpackChunkName: "pages/info/terms" */))
const _3c1b9780 = () => interopDefault(import('../../../pages/admin/_id.vue' /* webpackChunkName: "pages/admin/_id" */))
const _32ae85ee = () => interopDefault(import('../../../pages/room/_roomId/index.vue' /* webpackChunkName: "pages/room/_roomId/index" */))
const _1861f5dd = () => interopDefault(import('../../../pages/room/_roomId/2nd-party.vue' /* webpackChunkName: "pages/room/_roomId/2nd-party" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/admin",
    component: _5906a1d0,
    name: "admin"
  }, {
    path: "/demo",
    component: _34d0b7e0,
    name: "demo"
  }, {
    path: "/info",
    component: _7bac491b,
    name: "info"
  }, {
    path: "/login",
    component: _65407a9c,
    name: "login"
  }, {
    path: "/maintenance",
    component: _295cef5c,
    name: "maintenance"
  }, {
    path: "/info/about",
    component: _5bf46e56,
    name: "info-about"
  }, {
    path: "/info/contact",
    component: _330f0529,
    name: "info-contact"
  }, {
    path: "/info/privacy",
    component: _eb89dede,
    name: "info-privacy"
  }, {
    path: "/info/terms",
    component: _25aa0750,
    name: "info-terms"
  }, {
    path: "/admin/:id",
    component: _3c1b9780,
    name: "admin-id"
  }, {
    path: "/room/:roomId",
    component: _32ae85ee,
    name: "room-roomId"
  }, {
    path: "/room/:roomId?/2nd-party",
    component: _1861f5dd,
    name: "room-roomId-2nd-party"
  }, {
    path: "/",
    component: _0547af50,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
